import { BiddingBlockBidStatus } from '@ebalance/proto/bffuser/v1/bidding_block_model_pb'

/**
 * 約定結果。 全約定 / 未約定 / 失効 / 取消 の 4 値。 失効と取消は未約定と別の区分 (AC-BSP-047 / AC-BSP-048 / AC-BSP-049)。
 *
 * ブロック入札は all-or-nothing で処理されるため部分約定が存在しない
 * (AC-BSP-049)。 union に 'partial' を残すと将来の配線でスポット通常入札の
 * 区分をそのまま流用でき、 仕様に無い「部分約定」 を出せてしまうので持たない。
 */
export type BlockBidResult = 'full' | 'none' | 'expired' | 'cancelled'

// 約定結果テーブルの 4 分類 (全約定 / 失効 / 取消 / それ以外は未約定)。
// 失効 (EXPIRED と eSLJ の FAILED) と取消は未約定と別の区分 (AC-BSP-047 / AC-BSP-048 /
// AC-BSP-049。 ステータス列の区分と揃える)。 取下処理中・取下失敗は約定待ちと同じ表示。
const RESULT_BY_BID_STATUS: Record<BiddingBlockBidStatus, BlockBidResult> = {
  [BiddingBlockBidStatus.UNSPECIFIED]: 'none',
  [BiddingBlockBidStatus.PENDING]: 'none',
  [BiddingBlockBidStatus.MATCHED]: 'full',
  [BiddingBlockBidStatus.UNMATCHED]: 'none',
  [BiddingBlockBidStatus.FAILED]: 'expired',
  [BiddingBlockBidStatus.EXPIRED]: 'expired',
  [BiddingBlockBidStatus.CANCELLED]: 'cancelled',
  [BiddingBlockBidStatus.WITHDRAWING]: 'none',
  [BiddingBlockBidStatus.WITHDRAW_FAILED]: 'none',
}

/** leg の約定軸 → 約定結果の 4 分類。 */
export const toBlockBidResult = (
  status: BiddingBlockBidStatus,
): BlockBidResult => RESULT_BY_BID_STATUS[status]
